var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"paypal-payment-container"},[_c('PayPal',{ref:"paypal",attrs:{"client":_vm.credentials,"plan_id":_vm.plan_id,"vault":"true"},on:{"payment_authorized":_vm.purchase,"payment-completed":_vm.success,"payment-validation-error":_vm.validationError,"payment-error":_vm.error}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }